module.exports = __webpack_public_path__ + "img/home_banner_web_BG3.119eaf9b.png";